{
  "internalPortal": {
    "components": {
      "vendors": {
        "title": "Vendors",
        "addVendors": "Add Vendors",
        "createNewVendor": "Create New Vendor",
        "addVendorsNotifications": {
          "success_one": "Vendor added successfully",
          "success_other": "{{count}} vendors added successfully",
          "error": "Failed to add vendors"
        },
        "unlinkVendor": {
          "dialog": {
            "title": "Unlink this vendor?",
            "description": "This removes {{name}} from the organization's vendors.",
            "blocked": "{{name}} can't be unlinked because it is still in use in this organization.",
            "notLinked": "{{name}} is no longer linked to this organization. Refresh the vendor list.",
            "accountsToDelete_one": "{{count}} empty vendor account will be deleted.",
            "accountsToDelete_other": "{{count}} empty vendor accounts will be deleted.",
            "accountsWithNumberOrData_one": "{{count}} vendor account has an account number or data.",
            "accountsWithNumberOrData_other": "{{count}} vendor accounts have an account number or data.",
            "audits": {
              "title": "This vendor is part of audits",
              "description": "A vendor with audits in this organization can't be unlinked."
            }
          },
          "success": "Vendor unlinked successfully",
          "error": "Failed to unlink vendor"
        }
      },
      "vendorAccounts": {
        "title": "Vendor accounts",
        "actions": {
          "bulkEdit": "Bulk edit",
          "addAccount": "Add account",
          "edit": "Edit vendor account"
        },
        "table": {
          "columns": {
            "accountNumber": "Vendor account number",
            "vendor": "Vendor",
            "status": "Status",
            "spendCategory": "Spend category",
            "locations": "Locations",
            "attachedAudits": "Attached audits",
            "notesDescription": "Notes / description",
            "invoiceFrequency": "Invoice frequency",
            "summaryAccountNumber": "Summary account number",
            "glCode": "GL code",
            "customGlField": "Custom GL field",
            "glAllocations": "GL allocations",
            "usageLimit": "Usage limit",
            "dollarLimit": "Dollar limit",
            "paymentTerms": "Payment terms",
            "invoiceDay": "Invoice day",
            "billingType": "Billing type",
            "portalLoginEmailId": "Portal login email",
            "more": "More"
          }
        },
        "form": {
          "create": {
            "title": "Add new vendor account",
            "success": "Vendor account created successfully",
            "error": "Failed to create vendor account"
          },
          "copy": {
            "title": "Clone vendor account",
            "success": "Vendor account cloned successfully",
            "error": "Failed to clone vendor account"
          },
          "edit": {
            "title": "Edit",
            "success": "Vendor account updated successfully",
            "error": "Failed to update vendor account"
          },
          "noVendors": "No vendors found",
          "statusBanner": "The account number status is set to Active by default. You can change it later by editing the vendor account.",
          "assignedAuditsBanner_one": "This account number is tied to {{count}} existing audit. Any changes will affect those audits as well.",
          "assignedAuditsBanner_other": "This account number is tied to {{count}} existing audits. Any changes will affect those audits as well.",
          "assignedAuditsLabel": "assigned audits:",
          "vendorNotEditableTooltip": "You cannot edit the vendor for this vendor account. It is automatically assigned to the same vendor as the audit.",
          "accountNumberNotEditableTooltip": "You cannot edit the account number for this vendor account. It is tied to existing audits.",
          "fields": {
            "accountNumber": "Account number",
            "accountNumberRequiredForVsr": "Required for VSR",
            "vendor": "Vendor",
            "status": "Status",
            "accountName": "Account name",
            "spendCategories": {
              "label": "Spend categories",
              "withCount": "Spend categories ({{count}})",
              "empty": "No spend categories yet. Please select a vendor. Spend categories are automatically assigned to the selected vendor.",
              "none": "No spend categories assigned to this vendor.",
              "tooltip": "Spend categories are automatically assigned from the selected vendor.",
              "required": "At least one spend category is required.",
              "missing": "This vendor has no spend categories. Add them to the vendor before creating a vendor account.",
              "goToVendor": "Add spend categories"
            },
            "locations": "Locations",
            "notes": "Notes",
            "invoiceFrequency": "Invoice frequency",
            "summaryAccountNumber": "Summary account number",
            "glCode": "GL code",
            "customGlField": "Custom GL field",
            "glAllocations": "GL allocations",
            "usageLimit": "Usage limit",
            "dollarLimit": "Dollar limit",
            "paymentTerms": "Payment terms",
            "invoiceDay": "Invoice day",
            "billingType": "Billing type",
            "portalLoginEmailId": "Portal login email"
          },
          "validation": {
            "invoiceDay": "Invoice day must be a whole number between 1 and 31"
          }
        },
        "noData": {
          "withFilters": {
            "title": "No vendor accounts match your filters",
            "description": "Try adjusting your filters to find what you're looking for"
          },
          "withoutFilters": {
            "title": "No vendor accounts found",
            "description": "No vendor accounts found for this organization."
          }
        },
        "bulkEditModal": {
          "selectFields": {
            "subtitle": "The values you enter will replace the current values on all selected vendor accounts. Spend categories will be added to existing categories."
          },
          "statusOptions": {
            "active": "Active",
            "inactive": "Inactive"
          },
          "success": "Vendor accounts updated successfully",
          "error": "Bulk update failed. Please try again."
        }
      }
    }
  },
  "enums": {
    "InvoiceFrequency": {
      "bi_weekly": "Bi-weekly",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "bi_monthly": "Bi-monthly",
      "quarterly": "Quarterly"
    },
    "BillingType": {
      "paper": "Paper",
      "email": "Email",
      "portal": "Portal"
    }
  }
}
